var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "py-2" },
    [
      _c(
        "b-row",
        { staticClass: "mb-3" },
        [
          _c(
            "b-col",
            { attrs: { cols: "10" } },
            [
              _c("b-skeleton", {
                attrs: { type: "input", width: "95%", height: "1.5rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c("b-skeleton", {
                attrs: { type: "input", width: "95%", height: "1.5rem" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mb-3" },
        [
          _c(
            "b-col",
            { attrs: { cols: "10" } },
            [
              _c("b-skeleton", {
                attrs: { type: "input", width: "95%", height: "1.5rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c("b-skeleton", {
                attrs: { type: "input", width: "95%", height: "1.5rem" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mb-3" },
        [
          _c(
            "b-col",
            { attrs: { cols: "10" } },
            [
              _c("b-skeleton", {
                attrs: { type: "input", width: "95%", height: "1.5rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c("b-skeleton", {
                attrs: { type: "input", width: "95%", height: "1.5rem" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }